// extracted by mini-css-extract-plugin
export default {"DivContainer":"WingsCard_DivContainer__bI0eg","InlineDiv":"WingsCard_InlineDiv__5SUzS","Title":"WingsCard_Title__f6YA6"};